import React, { Fragment, useState } from "react";
import { DialogFooter, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { TableActionProps } from "../../types/table";
import { HouseForm } from "../../types/house-forms";
import { useDeleteHouseFormMutation } from "../../api/tenant/house-forms";
import Loading from "../../components/global/loading";

function DeleteHouseForm({ row, onClose }: TableActionProps<HouseForm>) {
    const [deleteHouseForm] = useDeleteHouseFormMutation();
    const [loading, setLoading] = useState<boolean>(false);

    async function handleSubmit() {
        setLoading(true);
        await deleteHouseForm(row.id);
        onClose();
        setLoading(false);
    }

    return (
        <Loading
            loaded={!loading}
            child={
                <Fragment>
                    <DialogHeader>
                        <DialogTitle>Remove {row.name}</DialogTitle>
                    </DialogHeader>
                    <DialogFooter>
                        <Button type="submit" onClick={handleSubmit} variant="destructive">
                            Remove
                        </Button>
                    </DialogFooter>
                </Fragment>
            }
        />
    );
}

export default DeleteHouseForm;
